import { createAction, createSlice } from "@reduxjs/toolkit";
import { queriesReducer, actionTypes } from "redux-query";
import { datapointsKey } from "store/middleware/analytics/analytics-grouping-middleware";
export * from "./types";
export const addPdfCustomQuery = createAction("customQueries/addPdfCustomQuery");
export const changePendingMessageForQuery = createAction("customQueries/changePendingMessageForQuery");
const isPostDatapointsSuccess = (action) => action.type === actionTypes.REQUEST_SUCCESS && action.queryKey?.includes(datapointsKey);
const updateQueryCache = (state, action, key) => {
    const listOfRequestsId = action.queryKey?.split("-").slice(1);
    const newQueryStates = {};
    if (listOfRequestsId.length > 1) {
        listOfRequestsId.forEach((id) => {
            const queryKey = `${key}-${id}`;
            const queryState = { isFinished: true,
                isMutation: false,
                isPending: false,
                lastUpdated: Date.now(),
                queryCount: (state[queryKey]?.queryCount || 0) + 1,
                status: action.status,
                url: action.url };
            newQueryStates[queryKey] = queryState;
        });
    }
    return {
        ...state,
        ...newQueryStates
    };
};
const initialState = {};
const slice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(addPdfCustomQuery, (state, action) => {
            const { key, query } = action.payload;
            state[key] = query;
        });
        builder.addCase(changePendingMessageForQuery, (state, action) => {
            const { key, message } = action.payload;
            state[key].pendingMessage = message;
        });
        builder.addMatcher((action) => Object.values(actionTypes).includes(action.type), (state, action) => queriesReducer(state, action));
        builder.addMatcher((action) => action.type === actionTypes.REQUEST_START || action.type === actionTypes.MUTATE_START, (state, action) => {
            state[action.queryKey] = { ...state[action.queryKey], ...action.meta };
            return state;
        });
        builder.addMatcher((action) => isPostDatapointsSuccess(action), (state, action) => updateQueryCache(state, action, datapointsKey));
    },
    initialState,
    name: "custom-queries",
    reducers: {}
});
export const customQueriesStateReducers = slice.reducer;
